import module from 'colaborador/module'
import template from './template.html'

export class ColaboradorCajaAhorroAgregarComponent {
  idProyecto
  idColaborador
  promise
  data = {
    beneficiarioId: undefined,
    plazo: null,
    importe: null,
    fechaInicial: null,
    fechaFinal: null,
    nominal: true,
  }

  constructor ($state) {
    this.$state = $state
  }

  agregar () {
    this.agregando = true
  }

  confirmar (data) {
    this.agregando = false

    if (data) {
      this.salir()
    }
  }

  salir () {
    this.$state.go('empleado.cajaAhorro.aportaciones')
  }

  finalizar (data) {
    if (data) {
      this.agregar()
    } else {
      this.salir()
    }
  }
}

module.component('colaboradorCajaAhorroAgregar', {
  controller: ColaboradorCajaAhorroAgregarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/aportaciones/agregar/component.js